import { AuditEntityType, IPagedCollection, IPerson, UserRemoteAccessSettingsDto } from '@sr/dto';
import { userApi } from 'entities/user/api';
import { USERS_BASE_URL } from 'shared/api/api';
import { CollectionParams } from 'shared/api/rtk-query';
import { pagingDataToParams } from 'utils/remote-paged-collection.hook';
import { invalidateEntityAudit } from 'entities/audit/utils';

const injectedUserApi = userApi.injectEndpoints({
  endpoints: (builder) => ({
    getByUserId: builder.query<UserRemoteAccessSettingsDto, number>({
      query: (userId: number) => `users/${userId}/remote-access`,
    }),
    getList: builder.query<IPagedCollection<UserRemoteAccessSettingsDto & { user: IPerson }>, CollectionParams>({
      query: ({ paging, filter }: CollectionParams) => ({
        url: `${USERS_BASE_URL}/remote-access/?${filter}`,
        params: paging && pagingDataToParams(paging),
      }),
    }),
    updateRemoteAccessSettings: builder.mutation<UserRemoteAccessSettingsDto, { userId: number; data: UserRemoteAccessSettingsDto }>({
      query: ({ userId, data }) => ({
        url: `${USERS_BASE_URL}/${userId}/remote-access`,
        body: data,
        method: 'PUT',
      }),
      async onQueryStarted({ userId }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          invalidateEntityAudit(dispatch, AuditEntityType.USER, userId);
        } catch (error) {
          console.error(error);
        }
      },
    }),
    deleteRemoteAccessSettings: builder.mutation<void, number>({
      query: (userId: number) => ({
        url: `users/${userId}/remote-access`,
        method: 'DELETE',
      }),
      async onQueryStarted(userId, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          invalidateEntityAudit(dispatch, AuditEntityType.USER, userId);
        } catch (error) {
          console.error(error);
        }
      },
    }),
  }),
});

export const userRemoteAccessApi = injectedUserApi.enhanceEndpoints({
  addTagTypes: ['remote-access'],
  endpoints: {
    getByUserId: {
      providesTags: (result, error, query) => (result ? [{ type: 'remote-access', id: query }] : ['remote-access']),
    },
    getList: {
      providesTags: (result, error, query) =>
        result
          ? [
              {
                type: 'remote-access',
                id: `${String(query.filter)}_${String(query.paging?.page)}_${String(query.paging?.itemsPerPage)}`,
              },
            ]
          : ['remote-access'],
    },
    deleteRemoteAccessSettings: {
      invalidatesTags: ['remote-access'],
    },
    updateRemoteAccessSettings: {
      invalidatesTags: ['remote-access'],
    },
  },
});
